import services from '@/config/services'

const source = 'fattureClientiDataTable'
const baseUrl = `${services.ask_api.url}/management`

const downloadFileZip = async(self, ids) => {
  self.$eventBus.emit('data-global-loading')
  
  const url = `${baseUrl}/clienti/fatture/bollettini-postali/zip`

  try {
    const res = await self.$http({
      url,
      method: 'POST',
      data: {
        "filters":{
          "fattura_vendita.numeri": ids
        },
        'isSaldo': true
      },
      responseType: 'blob',
    })
    .finally(() => {
      self.$eventBus.emit('data-global-loaded')
    })
    
    const blob = new Blob([res.data], {type: 'application/zip'});
    const fileName= window.decodeURI(res.headers['content-disposition'].split('=')[1], "UTF-8").split('"').join('')

    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (err) {
    self.$eventBus.emit('data-global-loaded')
    console.log(err)
  }
}

const getBollettiniPostali = function(){
  const keys = Object.keys(this.filtered.ids).filter((s) => s == source)
  if(keys.length > 0){
    const ids = this.filtered.ids[source].map((el) => el.value)
    downloadFileZip(this, ids);
  } 
}

export default {
  'bindTo': 'this',
  'method': getBollettiniPostali,
}
